import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { ApiService } from '../../services/api/api.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';

export const AuthenticationGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree => {

  const loader = inject(NgxUiLoaderService);
  const authService = inject(ApiService);
  const router = inject(Router);

  const isLoggedIn = authService.isAuthenticated();

  if (!isLoggedIn) {
    loader.stop();
    loader.stopAll();
    return router.parseUrl('/login');
  }

  return true;
};
